import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { ImagePlus, X } from "lucide-react";

export const productPhotoUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/products/photo/${id}`;

async function compressImage(file, maxSide = 800, quality = 0.8) {
  try {
    const dataUrl = await new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = rej;
      r.readAsDataURL(file);
    });
    const img = await new Promise((res, rej) => {
      const im = new Image();
      im.onload = () => res(im);
      im.onerror = rej;
      im.src = dataUrl;
    });
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const w = Math.round(img.width * scale);
    const h = Math.round(img.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob) return file;
    return new File([blob], (file.name.replace(/\.[^.]+$/, "") || "menu") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export function ProductPhotoSlot({ value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!f.type.startsWith("image/")) { toast.error("File harus berupa gambar"); return; }
    setBusy(true);
    try {
      const compressed = await compressImage(f);
      const fd = new FormData();
      fd.append("file", compressed);
      const { data } = await api.post("/products/photo", fd);
      onChange(data.id);
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  return (
    <div>
      <input ref={ref} type="file" accept="image/*" className="hidden" data-testid="np-photo-input" onChange={upload} />
      {value ? (
        <div className="relative h-24 w-24">
          <img src={productPhotoUrl(value)} alt="Foto menu" className="h-24 w-24 rounded-xl object-cover" />
          <button type="button" data-testid="np-photo-remove" onClick={() => onChange("")} className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-crimson text-white shadow"><X size={13} /></button>
        </div>
      ) : (
        <button type="button" data-testid="np-photo-btn" onClick={() => ref.current?.click()} disabled={busy}
          className="flex h-24 w-24 flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-neutral-300 bg-neutral-50 text-muted-foreground transition-colors hover:border-crimson hover:text-crimson">
          <ImagePlus size={20} /><span className="text-[10px] font-semibold">{busy ? "Upload…" : "Foto Menu"}</span>
        </button>
      )}
    </div>
  );
}
